import React from 'react';
import uniq from 'lodash.uniq';

import { useAppSelector } from 'js/store/hooks';
import { DEFAULT_DRAG_CURSOR_ID } from 'js/config/consts';

import HandMenu from '../AnimationPanels/HandMenu';
import { useAnimationStageContext } from '../AnimationPanels/AnimationStageContext';

const DragHandMenu = () => {
  const hands = useAppSelector(state => state.cursors.handDrag);
  const { currentSelectedCursor, onCursorChoice } = useAnimationStageContext();

  const filters = ['all', ...uniq(hands.map(hand => hand.group.toLowerCase()).sort())];

  return (
    <HandMenu
      hands={hands}
      onSelection={onCursorChoice}
      selectedCursorId={currentSelectedCursor}
      defaultCursorId={DEFAULT_DRAG_CURSOR_ID}
      defaultCursorGroup="rosie"
      filters={filters}
    />
  );
};

export default DragHandMenu;
